// extracted by mini-css-extract-plugin
module.exports = {"container":"UpdatedAtWithRefresh__container___1Dg7C","text":"UpdatedAtWithRefresh__text___1dPMZ","refreshIcon":"UpdatedAtWithRefresh__refreshIcon___323gX"};